// components/Navigation.js
import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Tab,
  Tabs,
  IconButton
} from '@mui/material';
import {
  Logout,
  Dashboard,
  History,
  Description
} from '@mui/icons-material';

const Navigation = ({ activeTab, onTabChange, onLogout }) => {
  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          💰 Sistema de Aumentos Progresivos
        </Typography>
        <Tabs 
          value={activeTab} 
          onChange={(e, newValue) => onTabChange(newValue)}
          textColor="inherit"
          sx={{ mr: 2 }}
        >
          <Tab icon={<Dashboard />} label="Clientes" />
          <Tab icon={<History />} label="Histórico" />
          <Tab icon={<Description />} label="Crear Documento" />
        </Tabs>
        <IconButton color="inherit" onClick={onLogout}>
          <Logout />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation;